import { normalizeInboxIdList } from './inboxIdsNormalize';

/**
 * Filtros do gatilho `message_created` em `node.data.message_filters`.
 *
 * Backend (executor do fluxo):
 * - `message_types`: lista de strings do enum `Message.message_type` (incoming, outgoing, activity).
 * - `exclude_private`: se true, não dispare para mensagens com `private == true`.
 * - `content_operator`: `none` | `contains` | `equal_to`. Com `none` ou texto vazio, ignora filtro de texto.
 * - `content_value`: texto comparado com `content` / `processed_message_content` da mensagem.
 * - `inbox_ids`: lista de IDs de caixa. Vazia = todas as caixas.
 */

export const MESSAGE_TYPE_OPTIONS = [
  { value: 'incoming', label: 'Recebida (contato)' },
  { value: 'outgoing', label: 'Enviada (equipe)' },
  { value: 'activity', label: 'Atividade' },
];

export const CONTENT_MATCH_OPERATOR_OPTIONS = [
  { value: 'none', label: 'Sem filtro de texto' },
  { value: 'contains', label: 'Contém' },
  { value: 'equal_to', label: 'Igual a' },
];

const ALLOWED_MESSAGE_TYPES = new Set(
  MESSAGE_TYPE_OPTIONS.map(o => o.value)
);

const ALLOWED_CONTENT_OPERATORS = new Set(
  CONTENT_MATCH_OPERATOR_OPTIONS.map(o => o.value)
);

export function defaultMessageFilters() {
  return {
    message_types: ['incoming'],
    exclude_private: true,
    content_operator: 'none',
    content_value: '',
    inbox_ids: [],
  };
}

export function normalizeMessageFilters(raw) {
  const defaults = defaultMessageFilters();
  if (!raw || typeof raw !== 'object') {
    return { ...defaults };
  }

  let message_types = Array.isArray(raw.message_types)
    ? raw.message_types.map(String).filter(t => ALLOWED_MESSAGE_TYPES.has(t))
    : defaults.message_types;
  if (!message_types.length) {
    message_types = [...defaults.message_types];
  }

  let content_operator = String(raw.content_operator || 'none');
  if (!ALLOWED_CONTENT_OPERATORS.has(content_operator)) {
    content_operator = 'none';
  }
  let content_value = String(raw.content_value ?? '').trim();
  if (content_operator === 'none') {
    content_value = '';
  }

  return {
    message_types,
    exclude_private: raw.exclude_private !== false,
    content_operator,
    content_value,
    inbox_ids: normalizeInboxIdList(raw.inbox_ids),
  };
}
